import React from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

function FadeInSection({
    children,
    delay = 0,
    direction = 'up', // 'up', 'down', 'left', 'right', 'none'
    className = '',
    threshold = 0.1
}) {
    const [ref, isVisible] = useScrollAnimation({ threshold });

    const getTransform = () => {
        switch (direction) {
            case 'up': return 'translateY(30px)';
            case 'down': return 'translateY(-30px)';
            case 'left': return 'translateX(30px)';
            case 'right': return 'translateX(-30px)';
            case 'none': return 'none';
            default: return 'translateY(30px)';
        }
    };

    return (
        <div
            ref={ref}
            className={className}
            style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translate(0, 0)' : getTransform(),
                transition: `opacity 0.8s ease-out ${delay}ms, transform 0.8s ease-out ${delay}ms`,
                willChange: 'opacity, transform'
            }}
        >
            {children}
        </div>
    );
}

export default FadeInSection;